// extracted by mini-css-extract-plugin
export var alertIcon = "_vf-0";